export default {
    general: {
        show_password: 'Show password',
        hide_password: 'Hide password',
        add: 'Add',
        edit: 'Edit',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
        search: 'Search',
        close: 'Close',
        confirm: 'Confirm',
        back: 'Back',
        actions: 'Actions',
        yes: 'Yes',
        no: 'No',
        loading: 'Loading …',
        select: 'Select',
        preview: 'Preview',
        download: 'Download',
        from: 'From',
        to: 'To',
        show: 'Show',
        hide: 'Hide',
        download_documents: 'Download documents',
        no_documents_to_download: 'There is no document to download',
    },
    owner_or_user: {
        owner_and_user: 'Owner/User',
        owner: 'Owner',
        user: 'User',
    },
    errors: {
        generic_error: 'An error occurred',
        load_data: 'Failed to load data',
        on_add: 'Failed to add',
        on_edit: 'Failed to save changes',
        on_delete: 'Failed to delete',
        on_sort: 'Failed to reorder',
        on_logout: 'Failed to log out',
        on_download: 'Failed to download the file',
        no_access: 'You do not have access',
    },
    api_errors: {
        not_signed_in: 'You are not signed in',
        forbidden: 'You are not allowed to do that',
        empty_object_key: 'The object code is required',
        empty_unit_key: 'The unit code is required',
        empty_document_type: 'The document type is required',
        empty_depository: 'The depository is required',
        empty_distributor_type: 'The distributor type is required',
        empty_supplier: 'The supplier is required',
        empty_date: 'The date is required',
        wrong_distributor_type: 'Wrong distributor type',
        wrong_date: 'Wrong date',
        wrong_type: 'Wrong type',
        not_own_unit: 'You do not have access to this unit',
        not_own_object: 'You do not have access to this object',
        not_own_document: 'You do not have access to this document',
        no_access_to_documents: 'You do not have access to the documents',
        no_access: 'You do not have access to this content',
        internal_server_error: 'Unknown internal server error',
        invalid_data: 'Invalid data received',
        not_found: 'Not found',
        unauthorized: 'You are not allowed to do that',
        invalid_password: 'Incorrect password',
        invalid_email: 'Invalid e-mail address',
        invalid_email_or_password: 'Incorrect e-mail or password',
        invalid_file_type: 'Unsupported document format',
        invalid_captcha: 'Invalid captcha',
        forgotten_password_expired: 'The password reset request has expired',
        invalid_bill_password: 'Invalid bill password',
        user_exists_by_email: 'A user with this e-mail already exists',
        user_exists_by_code_payer: 'A user with this payer code already exists',
        no_code_payer: 'The payer code does not exist',
        manager_missing: 'Manager data is missing',
        user_not_connected_to_manager: 'The user is not connected to a manager',
    },
    success: {
        add: 'Added successfully',
        edit: 'Saved successfully',
        delete: 'Deleted successfully',
        sort: 'Reordered successfully',
    },
    confirm: {
        default: 'Are you sure you want to continue?',
        delete_row: 'Are you sure you want to delete {name}',
    },
    validation: {
        required: 'This field is required',
        email: 'Invalid e-mail address',
        min_length: 'Enter at least {min} characters',
        at_least_one_uppercase: 'The password must contain at least one uppercase letter',
        at_least_one_digit: 'The password must contain at least one digit',
        passwords_must_match: 'Passwords do not match',
    },
    navigation: {
        menu: 'Menu',
        quick_overview: 'Quick overview',
        billing: 'Billing',
        regular_billing: 'Regular billing',
        reserve_fund_billing: 'Reserve fund billing',
        open_items: 'Open items',
        tenants_open_items: 'Tenant open items',
        card_traffic: 'Billing and payments card',
        readings: 'Heat billing',
        funds: 'Funds',
        reserve_fund: 'Reserve fund',
        voluntary_fund: 'Voluntary fund',
        reserve_fund_debtors: 'Reserve fund debtors',
        turnover_reserve_fund_books: 'Reserve fund postings',
        documents: 'Documents',
        manager_documents: 'Manager documents',
        supplier_documents: 'Supplier documents',
        notifications: 'Notifications',
        your_units: 'Your units',
        bulletin_board: 'Bulletin board',
        faq: 'FAQ',
        contractors: 'Contractors',
        cost_specification: 'Cost specification',
        registered_people_and_dogs: 'Registered number of people and dogs',
        insurance_contracts: 'Insurance contracts',
        forms: 'Forms',
        profile: 'Profile',
        change_password: 'Change password',
        add_manager: 'Add manager',
        logout: 'Log out',
    },
    billing: {
        cost_distributors: 'Cost distributors:',
        naziv: 'Name',
        skupaj_eur: 'Total (€)',
        osnova_za_ddv: 'VAT base',
        ddv_skupaj: 'VAT total',
        skupaj_stroski: 'Total costs',
        skupaj_poraba_sred_rezervnega_sklada: 'Total reserve fund usage',
        skupni_znesek_za_placilo: 'Total amount due',
        ddv: 'VAT',
        stopnja_pct: 'Rate (%)',
        osnova_za_ddv_eur: 'VAT base (€)',
        znesek_za_ddv_eur: 'VAT amount (€)',
        skupaj_poraba_prostovoljno_zbranih_sredstev: 'Total voluntary fund usage',
        skupaj_poraba_rezervnega_sklada: 'Total reserve fund usage',
        vse_skupaj: 'Grand total',
        ni_podatkov_za_prikaz: 'No data to display',
        skupaj: 'Total',
        skupaj_ddv_eur: 'VAT total (€)',
        skupaj_za_placilo_enota: 'Unit total due',
        vse_skupaj_za_placilo: 'Grand total due',
        rekapitulacija_po_ddv_stopnjah: 'Recapitulation by VAT rate',
        celoten_znesek_eur: 'Full amount (€)',
        kljuc_delitve: 'Split key',
        kolicina: 'Quantity',
        sk_kol: 'Total qty.',
        cena_za_razdelitve_eur: 'Unit price for split (€)',
        stopnja_ddv_pct: 'VAT rate (%)',
        znesek_ddv_eur: 'VAT amount (€)',
        vrsta_stroska: 'Cost type',
        interna_st: 'Internal no.',
        st_orig_rac: 'Original invoice no.',
        datum_racuna: 'Invoice date',
        poraba_sredstev_rezervnega_sklada: 'RESERVE FUND USAGE',
        opis: 'Description',
        oprema_storitev: 'Service period',
        ds_id_za_ddv: 'VAT ID',
        dobavitelj: 'Supplier',
        sedez: 'Registered office',
        stroski: 'Costs',
        poraba: 'Usage',
        datum_od_do: 'Date from-to',
        strosek: 'Cost',
        osnova_ddv_eur: 'VAT base (€)',
        ddv_eur: 'VAT (€)',
    },
    distributor: {
        razdelilnik_stroskov: 'Cost distributor',
        sifra_placnika: 'Payer code',
        referenca_za_placilo: 'Payment reference',
        st_racuna_za_placilo: 'Payment account no.',
        ds_id: 'Tax ID',
        naziv_objekta: 'Building name',
        naziv_vhoda: 'Entrance name',
        no_chart_data: 'No data to draw the chart',
    },
    home: {
        latest_bulletin: 'Latest notice',
        no_bulletins: 'There are no notices on the bulletin board',
        no_notifications: 'No notifications to display',
    },
    units: {
        no_active_title: 'No active units',
        no_active_body: 'You currently have no active unit for the selected manager {manager}. Choose a different manager or contact them for more information.',
    },
    card_traffic: {
        payment_date_note: '(where a charge was settled by several partial payments, PAYMENT DATE shows the date of the last one)',
        consumption_note: '*Usage means drawing funds from the reserve or voluntary fund, or from any customer overpayments',
    },
    open_items: {
        saldo_ro: 'Balance - regular billing (RO)',
        saldo_rs: 'Balance - reserve fund billing (RS)',
        saldo_total: 'Total balance',
        tenants_total: 'Total open items of tenants',
        ro: 'RO',
        rs: 'RS',
    },
    tenants: {
        zap_st: 'Seq. no.',
        partner: 'Partner',
        skupaj_partner: 'Partner total',
        vse_skupaj: 'Grand total',
    },
    registered: {
        note: '(the figures shown apply to the current period, which may differ from the distributors, which as a rule apply to the previous month)',
        ulica_hisna_stevilka: 'Street and house number',
        postna_stevilka_kraj: 'Post code and town',
        stevilo_oseb: 'Number of people',
        stevilo_psov: 'Number of dogs',
        vhod: 'Entrance',
        skupaj_vhod: 'Entrance total',
        skupaj_objekt: 'Building total',
    },
    manager_documents: {
        main_depository: 'Main depository',
        depository: 'Depository',
    },
    readings: {
        heat_energy: 'Heat energy',
        hot_water: 'Hot water',
        cold_water: 'Cold water',
    },
    notifications: {
        empty: 'There are currently no notifications.',
    },
    fields: {
        unit_no: 'Unit no.',
        parcel: 'Parcel',
        size_net: 'Net size',
        size_gross: 'Gross size',
        breme_eur: 'Debit (€)',
        datum_dokumenta: 'Document date',
        datum_placila: 'Payment date',
        datum_pogodbe: 'Contract date',
        datum_valute: 'Value date',
        datum_veljavnosti_do: 'Valid until',
        datum_veljavnosti_od: 'Valid from',
        datum: 'Date',
        depoziti_eur: 'Deposits (€)',
        dobro_eur: 'Credit (€)',
        dvigi_eur: 'Withdrawals (€)',
        email: 'E-mail',
        faktor: 'Factor',
        gurs_st_enote: 'GURS unit no.',
        gurs_st_stavbe: 'GURS building no.',
        izberite_enoto: 'Select a unit',
        leto: 'Year',
        mesec: 'Month',
        naziv_izvajalca: 'Contractor name',
        naziv_partnerja: 'Partner name',
        naziv_stroska: 'Cost name',
        naziv_zavarovalnice: 'Insurer name',
        naziv: 'Name',
        neplacano_eur: 'Unpaid (€)',
        nosilec_stroska: 'Cost bearer',
        objekt: 'Object',
        obracun: 'Billing',
        opis: 'Description',
        opomba: 'Note',
        otvoritev_11_eur: 'Opening (1 Jan) (€)',
        placano_eur: 'Paid (€)',
        placila_eur: 'Payments (€)',
        poraba_eur: 'Usage (€)',
        porabastar_eur: 'Usage* (€)',
        prenesi_dokumente: 'Download documents',
        saldo_eur: 'Balance (€)',
        sestevek_v_dobro_eur: 'Credit total (€)',
        sklic: 'Reference',
        skupaj: 'Total',
        skupni_prostori: 'Common areas',
        stanje_eur: 'Balance (€)',
        stanje_sredstev: 'Funds balance',
        stanje_terjatev: 'Receivables balance',
        telefon: 'Phone',
        terjano_eur: 'Charged (€)',
        terjatev_eur: 'Receivable (€)',
        vrsta_prostovoljnega_sklada: 'Voluntary fund type',
        vrsta_zavarovanja: 'Insurance type',
        vrsta: 'Type',
        zaporedna_st_enote: 'Unit sequence no.',
        znesek_po_obracunu_eur: 'Billed amount (€)',
        znesek_premije_eur: 'Premium amount (€)',
        znesek_stroskov_eur: 'Cost amount (€)',
        odliv_eur: 'outflow (€)',
        priliv_eur: 'inflow (€)',
        stevilka_pogodbe: 'Contract number',
        gurs_st_dela_stavbe: 'GURS building part no.',
        solastniski_delez: 'Co-ownership share',
        ogrevalna_povrsina: 'Heated area',
        vrsta_enote: 'Unit type',
        vrsta_prostora: 'Room type',
        st_oseb: 'No. of people',
        st_psov: 'No. of dogs',
        invent_st: 'Inventory no.',
        zap_st_enote: 'Unit seq. no.',
        solast_del: 'Co-own. share',
        enota: 'Unit',
    },
    pages: {
        chart_view: 'Chart view',
        cost_chart: 'Cost chart',
        virtual_reserve_fund: 'Virtual reserve fund balance',
        download_e_invoice: 'Download e-invoice',
        show_e_invoice: 'Show e-invoice',
        download_invoices: 'Download invoices',
    },
    forms: {
        title: 'Forms',
        change_people_or_animals: 'Form for changing the number of people or dogs',
        spectator_notice: 'You are viewing another user profile. Submitting a form is disabled.',
        full_name: 'Full name',
        declaration: 'Declaration',
        declaration_from: 'I declare that the unit, from:',
        declaration_uses: 'is used by',
        declaration_users_and: 'users, and that the unit houses',
        declaration_dogs: 'dogs.',
        people_count: 'Number of users',
        dogs_count: 'Number of dogs',
        signature_notice: 'By signing I vouch for the accuracy of this data. This declaration is used to bill all operating costs that are split across the building on a per-user basis.',
        send: 'Send',
        send_success: 'The form was sent successfully',
        send_error: 'Failed to send the form',
    },
    profile: {
        title: 'Profile',
        name: 'Name',
        address: 'Address',
        post_code: 'Post code',
        city: 'City',
        country: 'Country',
        code: 'Code',
        change_email: 'Change e-mail',
        email_updated: 'E-mail updated successfully',
        email_update_error: 'Failed to update the e-mail',
    },
    regular_billing: {
        date: 'Date',
        year_month: 'Year/month',
        cost_split: 'Cost split',
        e_invoice: 'e-Invoice',
    },
    supplier_documents: {
        period: 'Period',
        supplier: 'Supplier',
    },
    unit: {
        label: 'Unit',
        search: 'Search units …',
    },
    footer: {
        all_rights_reserved: 'All rights reserved',
    },
    manager: {
        label: 'Manager',
        search: 'Search managers …',
        no_results: 'No results',
        switch_success: 'Manager switched successfully',
        switch_error: 'Failed to switch manager',
    },
    table: {
        empty: 'No data to display',
        reload: 'Reload',
        clear_filters: 'Clear filters',
        search_by: 'Search by {field}',
        pick_option: 'Pick an option',
        pick_date: 'Pick a date',
        page_report: '{first} - {last} of {total}',
        press_enter: 'Press enter to search',
        total: 'Total:',
    },
    editor: {
        images_not_allowed: 'Inserting images is not allowed!',
        audio_not_allowed: 'Inserting audio is not allowed!',
        video_not_allowed: 'Inserting video is not allowed!',
    },
    upload: {
        file: 'File',
        files_and_photos: 'Files and photos',
        drop_hint: 'Drag and drop files to upload.',
        uploaded: 'Uploaded',
        clear: 'Remove',
    },
    login: {
        email: 'E-mail',
        password: 'Password',
        remember_me: 'Remember me',
        forgotten_password: 'Forgot your password?',
        register: 'Register',
        submit: 'Sign in',
        error: 'Your e-mail or password does not match our records',
    },
    register: {
        submit: 'Register',
        to_login: 'Sign in',
        success: 'Registration successful',
        error: 'Registration failed',
    },
    add_manager: {
        title: 'Add manager',
        submit: 'Add manager',
        success: 'The manager was added successfully',
        spectator_notice: 'You are viewing another user profile. Adding a manager is disabled.',
    },
    change_password: {
        password_help: 'The password must be at least 8 characters long and contain at least one uppercase letter and one digit.',
        spectator_notice: 'You are viewing another user profile. Changing the password is disabled.',
        title: 'Change password',
        current: 'Current password',
        new: 'New password',
        repeat: 'Confirm password',
        submit: 'Change password',
        success: 'Password changed successfully',
        error: 'Failed to change the password',
    },
    forgotten_password: {
        title: 'Forgotten password',
        intro: 'Enter your e-mail address below and we will send you instructions to reset your password.',
        submit: 'Reset password',
        sent_title: 'Password reset instructions sent!',
        sent_body: 'Instructions on how to reset your password were sent to the e-mail address you entered. The password must be reset within 24 hours.',
        back_to_login: 'Back to sign in',
        captcha_error: 'The captcha could not be solved. Please refresh the page.',
        send_error: 'Failed to send the e-mail',
    },
    reset_password: {
        title: 'Reset your password',
        intro: 'Enter your new password below.',
        new: 'New password',
        repeat: 'Repeat password',
        submit: 'Reset password',
        success: 'Your password was reset successfully!',
        error: 'Failed to reset the password',
    },
    connect_manager: {
        title: 'You have to connect a manager before signing in again',
    },
    login_as_user: {
        failed_title: 'Sign-in failed!',
        failed_body: 'Close this tab and try again from the admin portal.',
    },
    not_found: {
        title: 'Page not found!',
        subtitle: 'We could not find the page you were looking for.',
        back_home: 'Back to the home page',
    },
    user: {
        title: 'Users',
        add: 'Add user',
        firstname: 'First name',
        lastname: 'Last name',
        email: 'E-mail',
        code_payer: 'Payer code',
        address: 'Address',
        post_code: 'Post code',
        city: 'City',
        post_and_city: 'Post code and city',
        password: 'Password',
        password_help: 'The password must be at least 8 characters long and contain at least one uppercase letter and one digit.',
        bill_password: 'Bill password',
        bill_password_help: 'You can find the password on your bill.',
        generate: 'Generate',
        check_email: 'Check the user e-mail',
        enter_valid_email: 'Enter a valid e-mail address',
        change_password: 'Change password',
        change_user_password: 'Change the user password',
        switch_to: 'Switch',
        switch_error: 'Failed to switch to the user',
        export: 'Export users',
        export_error: 'Failed to export the users',
        unlink: 'Unlink',
        unlink_confirm: 'Are you sure you want to unlink the user: {firstname} {lastname} - {code_payer}?',
        unlink_success: 'The user was unlinked successfully',
        unlink_error: 'Failed to unlink the user',
    },
    partner: {
        title: 'Partners',
        name: 'Name',
        code: 'Code',
        address: 'Address',
        post_code: 'Post code',
        city: 'City',
        password: 'Password',
        password_set: 'Password is set',
        password_not_set: 'Password is not set',
        switch_to: 'Switch',
        switch_error: 'Failed to switch to the partner',
    },
    depository: {
        title: 'Depositories',
        add: 'Add depository',
        base: 'Base depository',
        display_name: 'Display name',
        content: 'Depository content',
        content_of: 'Depository content: {name}',
        delete_name: 'depository: {name}?',
        filter_by_building: 'Filter by building',
        document_name: 'Name',
        subject: 'Subject',
        partner: 'Partner',
        document_date: 'Document date',
        format: 'Format',
        no_file: 'The document has no file',
        download_error: 'Failed to download the document',
    },
    bulletin: {
        title: 'Bulletin board',
        add: 'Add notice',
        edit: 'Edit notice',
        name: 'Title',
        content: 'Content',
        buildings: 'Buildings',
        pick_buildings: 'Pick buildings',
        limit_to_buildings: 'Limit to buildings',
        limited_to_building: 'Limited to building',
        active: 'Active notice',
        delete_name: 'notice: {title}?',
        empty: 'There are currently no items on the bulletin board',
    },
    faq: {
        title: 'FAQ',
        add: 'Add question',
        position: 'Order',
        question: 'Question',
        answer: 'Answer',
        delete_name: 'question: {question}?',
    },
    allowed_pages: {
        title: 'Allowed pages',
        page_name: 'Page name',
        pages: {
            regular_billing: 'Regular billing',
            reserve_fund_billing: 'Reserve fund billing',
            open_items: 'Open items',
            card_traffic: 'Billing and payments card',
            readings: 'Heat billing',
            reserve_fund: 'Reserve fund',
            voluntary_fund: 'Voluntary fund',
            reserved_fund_debtors: 'Reserve fund debtors',
            reserved_fund_postings: 'Reserve fund postings',
            manager_documents: 'Manager documents',
            supplier_documents: 'Supplier documents',
            notifications: 'Notifications',
            your_units: 'Your units',
            bulletin_board: 'Bulletin board',
            faq: 'FAQ',
            contractors: 'Contractors',
            cost_specification: 'Cost specification',
            tenants: 'Tenants',
            registered_people_and_dogs: 'Registered number of people and dogs',
            insurance_contracts: 'Insurance contracts',
        },
    },
}
